import { LoginContext } from "helpers/LoginContext";
import { useContext } from "react";
export const useScrollToTop = () => {
  const context = useContext(LoginContext);
  if (!context) {
    throw new Error("useScrollToTop must be used within a LoginProvider");
  }
  return context.scrollToTop;
};
